import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  validColor,
  invalidColor,
  noDataColor,
} from '../../utils/styleConst';

const ListStyle = styled.ul`
    color: #333;
    font-size: 13px;
    background-color: white;
    font-weight: 400;
    line-height: 1.4;

    li {

      :first-letter {
        text-transform:capitalize;
      }

      :first-child {
        font-size: 14px;
        font-weight: 500;
      }

      &.capacity {
        font-weight: 500;
        color: ${props => (props.free > 0 ? validColor : invalidColor)};

        &.no-data {
          color: ${noDataColor}
        }
      }

      a {
        color: #427fed;
        text-decoration: none;

        &:hover, &:focus, &:active {
          text-decoration: underline;
        }
      }

    }
`;

const getAvailablePlacesDisplay = (studio) => {
  let display = studio.availablePlaces + ' place(s) restante(s)';

  if (typeof studio.options === 'object' && !Array.isArray(studio.options)) {
    display += ' dont ';

    if (studio.options['electrical_outlet']) {
      display += studio.options['electrical_outlet'].free + ' place(s) avec prise électrique';
    }

    if (studio.options['child_seat']) {
      if (studio.options['electrical_outlet']) {
        display += ' et ';
      }

      display += studio.options['child_seat'].free + ' place(s) siège enfant';
    }
  }

  return display;
}

const List = ({ studio }) => {
  const isFree = studio.availablePlaces !== 0;

  return (
    <ListStyle free={isFree}>
      <li>{studio.name}</li>
      <li>{studio.streetAddress}, {studio.postalCode} {studio.addressLocality}</li>
      <li>Abri de {studio.capacity} places</li>
      {isFree ? (
        <li className="capacity">{getAvailablePlacesDisplay(studio)}</li>
      ) : (
        <li className="capacity">Aucune place restante</li>
      )}
      <li><a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(studio.streetAddress)},+${encodeURIComponent(studio.addressLocality)}`}>Voir dans Google Maps</a></li>
    </ListStyle>
  );
};

List.propTypes = {
  studio: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};
export default List;




// WEBPACK FOOTER //
// src/components/googleMap/List.jsx